import { render, staticRenderFns } from "./SetupPhoneHandoff.vue?vue&type=template&id=6aae9284&scoped=true"
import script from "./SetupPhoneHandoff.vue?vue&type=script&lang=js"
export * from "./SetupPhoneHandoff.vue?vue&type=script&lang=js"
import style0 from "./SetupPhoneHandoff.vue?vue&type=style&index=0&id=6aae9284&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aae9284",
  null
  
)

export default component.exports